import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import MakeAgentModal from "../components/MakeAgentModal";

export default function Top({ selectedNotice, setSelectedNotice, setIsLoggedIn }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [unreadNotices, setUnreadNotices] = useState([]);
  const [showModifyModal, setShowModifyModal] = useState(false);
  const [modifyData, setModifyData] = useState(null);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const parseJsonSafe = (value, fallback = null) => {
    if (!value || value === "undefined" || value === "null") return fallback;
    try {
      return JSON.parse(value);
    } catch {
      return fallback;
    }
  };

  const routeTitles = {
    '/': () => <>Dashboard</>,
    '/DailyAD': () => <>일별 정산</>,
    '/DailyAM': () => <>월별 정산</>,
    '/users': () => <>회원 관리</>,
    '/userInfo': () => <> 회원 정보</>,
    '/trxsAll': () => <>전체 거래</>,
    '/exchangeDayList': () => <>환율 정보</>,
    '/ReportPartner': () => <> 에이전트 지급/회수</>,
    '/Vendors': () => <> 벤더관리/한도제한</>,
    '/LogsSend': () => <>실패로그</>,
    '/LimitChangeLogs': () => <>제한변경 로그</>,
    '/loginLog': () => <>로그인 로그</>,
    '/Notice': () => <> 공지사항</>,
    '/NoticeUpdate': () => <>업데이트</>,
    '/MyMoney': () => <>나의머니</>,
    '/TransferOther': () => <> 에이전트/회원 거래내역</>,
    '/AgentsReg': () => <> 에이전트 승인관리</>,
    // '/ApiDoc':() => <> API소개</>,
    // '/ApiCommon':() => <> 공통 API</>,
    '/agents': () => <>에이전트관리<span className="ms-1">하위전체</span></>,
    '/agentInfo': () => <>에이전트정보<span className="ms-1">상세</span></>,
    '/Gamelimit': () => <>최대 당첨금액 설정</>,
    '/GameLimitList': () => <>당첨한도 초과 회수 기록</>,
    '/NewGame': () => <>신규게임 목록</>,
    '/NoKor': () => <>한글 누락 리스트</>,
  };

  const title = routeTitles[location.pathname]?.() || <>Dashboard</>;

  // 로그아웃 처리
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("first");
    localStorage.removeItem("unreadNotice");
    setIsLoggedIn(false);
    navigate("/login");
  };

  // 모두 읽음 처리
  const handleReadAll = async () => {
    try {
      const storedUser = parseJsonSafe(localStorage.getItem("first"), null);
      if (!storedUser?.user_id) return;
      const res = await fetch(`${API_BASE}/api/notice/read-all`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: storedUser.user_id }),
      });

      if (res.ok) {
        setUnreadNotices([]);
        localStorage.removeItem("unreadNotice");
      }
    } catch (err) {
      console.error("모두 읽기 실패:", err);
    }
  };

  // 초기 유저 및 안읽은 공지 로드
  useEffect(() => {
    const storedUser = localStorage.getItem("first");
    const unread_notices = localStorage.getItem("unreadNotice");

    const parsedUser = parseJsonSafe(storedUser, null);
    if (!parsedUser) {
      if (storedUser === "undefined" || storedUser === "null") {
        localStorage.removeItem("first");
      }
      return;
    }

    setUser(parsedUser);

    const parsedNotices = parseJsonSafe(unread_notices, []);
    setUnreadNotices(Array.isArray(parsedNotices) ? parsedNotices : []);
  }, []);

  // 선택된 공지 읽음 처리
  useEffect(() => {
    if (selectedNotice && user) {
      axios
        .post(`${API_BASE}/api/notice/mark-as-read`, {
          user_id: user.user_id,
          board_id: selectedNotice.idx,
        })
        .then(() => {
          setUnreadNotices((prev) =>
            prev.filter((notice) => notice.idx !== selectedNotice.idx)
          );
        })
        .catch((err) => {
          console.error("읽음 처리 실패:", err);
        });
    }
  }, [selectedNotice, user]);


  const handleClick = (e) => e.preventDefault();

  if (!user) return <div>로딩 중...</div>;

  return (
    <div className="nk-header nk-header-fixed is-theme">
      <div className="container-fluid">
        <div className="nk-header-wrap">
          <div className="nk-menu-trigger d-xl-none ms-n1">
            <a
              href="#"
              className="nk-nav-toggle nk-quick-nav-icon"
              data-target="sidebarMenu"
              onClick={handleClick}
            >
              <em className="icon ni ni-menu"></em>
            </a>
          </div>

          <div className="nk-header-brand d-xl-none">
            <a href="html/index.html" className="logo-link">
              <img
                className="logo-light logo-img"
                src="/images/logo_matrix_mo.png"
                srcSet="/images/logo_matrix_mo_3x.png 3x"
                alt="logo"
              />
              <img
                className="logo-dark logo-img logo-img-lg"
                src="/images/logo_matrix_mo.png"
                srcSet="/images/logo_matrix_mo_3x.png 3x"
                alt="logo-dark"
              />
            </a>
          </div>

          <div className="nk-header-news nk-header-title d-xl-block">
            <div className="nk-news-list">
              <div className="nk-news-item">
                <div className="nk-news-icon">
                  <em className="icon ni ni-file-docs"></em>
                </div>
                <div className="nk-news-text">
                  <p>{title}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="nk-header-tools">
            <ul className="nk-quick-nav">
              <li className="dropdown language-dropdown me-n1">
                <a
                  href="#"
                  className="dropdown-toggle nk-quick-nav-icon"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={handleClick}
                >
                  <div className="quick-icon border border-light bg-primary">
                    <span style={{ marginTop: "-8px" }}>
                      <i>
                        <svg
                          height="28"
                          viewBox="0 0 512 512"
                          width="512pt"
                          xmlns="http://www.w3.org/2000/svg"
                          id="fi_1827336"
                        >
                          <path
                            d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0"
                            fill="#2196f3"
                          ></path>
                          <path
                            d="m377.75 388.414062c-4.160156 4.160157-9.621094 6.253907-15.082031 6.253907-5.460938 0-10.925781-2.09375-15.082031-6.253907l-106.667969-106.664062c-4.011719-3.988281-6.25-9.410156-6.25-15.082031v-138.667969c0-11.796875 9.554687-21.332031 21.332031-21.332031s21.332031 9.535156 21.332031 21.332031v129.835938l100.417969 100.414062c8.339844 8.34375 8.339844 21.824219 0 30.164062zm0 0"
                            fill="#fff"
                          ></path>
                        </svg>
                      </i>
                    </span>
                  </div>
                </a>
                <div className="dropdown-menu dropdown-menu-end dropdown-menu-s1 time-zone">
                  <ul
                    className="language-list"
                    style={{ height: "300px", overflowY: "scroll" }}
                  >
                    {[
                      "-12:00",
                      "-11:00",
                      "-10:00",
                      "-09:00",
                      "-08:00",
                      "-07:00",
                      "-06:00",
                      "-05:00",
                      "-04:00",
                      "-03:00",
                      "-02:00",
                      "-01:00",
                      "",
                      "+1:00",
                      "+2:00",
                      "+3:00",
                      "+4:00",
                      "+5:00",
                      "+6:00",
                      "+7:00",
                      "+8:00",
                      "+9:00",
                      "+10:00",
                      "+11:00",
                      "+12:00",
                    ].map((utc) => (
                      <li key={utc} style={{ cursor: "pointer" }}>
                        <a
                          href="#"
                          className="language-item"
                          onClick={handleClick}
                        >
                          UTC {utc}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>

              <li className="dropdown language-dropdown me-n1">
                <a
                  href="#"
                  className="dropdown-toggle nk-quick-nav-icon show"
                  data-bs-toggle="dropdown"
                  onClick={handleClick}
                >
                  <i className="fas fa-tablet-alt"></i>
                </a>
                <div className="dropdown-menu dropdown-menu-end dropdown-menu-s1">
                  <ul className="language-list">
                    <li>
                      <a
                        href="#"
                        className="language-item"
                        onClick={handleClick}
                      >
                        <i className="fas fa-search-minus"></i> &nbsp; 화면 축소
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="language-item"
                        onClick={handleClick}
                      >
                        <i className="fas fa-search-plus"></i> &nbsp; 화면 확대
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="language-item"
                        onClick={handleClick}
                      >
                        <i className="fas fa-redo"></i> &nbsp; 초기화
                      </a>
                    </li>
                  </ul>
                </div>
              </li>

              <li className="dropdown language-dropdown d-none d-sm-block me-n1">
                <a
                  href="#"
                  className="dropdown-toggle nk-quick-nav-icon"
                  data-bs-toggle="dropdown"
                  onClick={handleClick}
                >
                  <div className="quick-icon border border-light">
                    <img
                      className="icon"
                      src="/images/flags/kor-sq.png"
                      alt=""
                    />
                  </div>
                </a>
                <div className="dropdown-menu dropdown-menu-end dropdown-menu-s1">
                  <ul className="language-list">
                    {[
                      ["english.png", "English"],
                      ["china.png", "简体中文"],
                      ["kor.png", "한국어"],
                      ["jp.png", "日本語"],
                      ["thailand.png", "ภาษาไทย"],
                      ["mongolia.png", "Монгол"],
                      ["vietnam.png", "Tiếng Việt"],
                      ["brazil.png", "Português"],
                      ["ph.png", "Filipino"],
                      ["indonesia.png", "Bahasa Indonesia"],
                      ["in.png", "हिंदी"],
                    ].map(([flag, name]) => (
                      <li key={flag}>
                        <a
                          href="#"
                          className="language-item"
                          onClick={handleClick}
                        >
                          <img
                            src={`/images/flags/${flag}`}
                            alt={flag}
                            className="language-flag"
                          />
                          <span className="language-name">{name}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>

              <li className="dropdown user-dropdown">
                <a
                  href="#"
                  className="dropdown-toggle"
                  data-bs-toggle="dropdown"
                  onClick={handleClick}
                >
                  <div className="user-toggle">
                    <div className="user-avatar sm d-md-block d-md-none">
                      <em className="icon ni ni-user-alt"></em>
                    </div>
                    <div className="user-info d-none d-md-block">
                      <div className="user-status">{user.user_id}</div>
                      <div className="user-name dropdown-indicator">
                        {user.user_id}
                      </div>
                    </div>
                  </div>
                </a>
                <div className="dropdown-menu dropdown-menu-md dropdown-menu-end dropdown-menu-s1">
                  <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
                    <div className="user-card">
                      <div className="user-avatar">
                        <span>{user.user_id.charAt(0)}</span>
                      </div>
                      <div className="user-info">
                        <span className="lead-text">{user.user_id}</span>
                        <span className="sub-text">{user.user_id}</span>
                      </div>
                    </div>
                  </div>
                  <div className="dropdown-inner">
                    <ul className="link-list">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setModifyData(user);   // ← MakeAgentModal 에 넘길 데이터
                            setShowModifyModal(true);
                          }}
                        >
                          <em className="icon ni ni-user-alt"></em>
                          <span>정보수정</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="dropdown-inner">
                    <ul className="link-list">
                      <li>
                        <a href="#" onClick={logout}>
                          <em className="icon ni ni-signout"></em>
                          <span>로그아웃</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>

              <li className="dropdown notification-dropdown me-n1">
                <a
                  href="#"
                  className="dropdown-toggle nk-quick-nav-icon"
                  data-bs-toggle="dropdown"
                  onClick={handleClick}
                >
                  <div className="icon-status icon-status-info">
                    <em className="icon ni ni-bell"></em>
                  </div>
                </a>
                <div className="dropdown-menu dropdown-menu-xl dropdown-menu-end dropdown-menu-s1">
                  <div className="dropdown-head">
                    <span className="sub-title nk-dropdown-title">
                      공지사항
                    </span>
                    <a href="#" onClick={handleClick}>
                      Notes List
                    </a>
                  </div>
                  <div className="dropdown-body">
                    <ul className="chat-list">
                      {unreadNotices.length > 0 ? (
                        unreadNotices.map((notice, idx) => (
                          <li className="chat-item" key={idx}>
                            <a
                              href="#"
                              className="chat-link"
                              data-bs-toggle="modal"
                              data-bs-target="#modalNotiView"
                              onClick={() => setSelectedNotice(notice)}
                            >
                              <div className="nk-notification-icon">
                                <em className="icon icon-circle bg-success-dim ni ni-curve-down-right"></em>
                              </div>
                              <div className="chat-info">
                                <div className="chat-context">
                                  <div className="text">
                                    〓 {notice.subject} 〓
                                  </div>
                                  <div className="status delivered text-success">
                                    <em className="icon ni ni-check-circle-fill"></em>
                                    <span style={{ fontSize: "80%" }}></span>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </li>
                        ))
                      ) : (
                        <li className="chat-item text-center text-muted">
                          안 읽은 공지 없음
                        </li>
                      )}
                    </ul>
                  </div>
                  <div className="dropdown-foot center">
                    <a href="#" onClick={(e) => { e.preventDefault(); handleReadAll(); }}>
                      모두 읽기
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {showModifyModal && (
        <MakeAgentModal
          agent={modifyData}
          show={showModifyModal}
          type={modifyData?.user_id === "root" ? 3 : 1}
          onClose={() => setShowModifyModal(false)}
          modalId="ModalInputMadeUser_top"
        />
      )}
    </div>

  );
}
